var map = {
	"./blue.png": 2331,
	"./cyan.png": 955,
	"./darkpurple.png": 1336,
	"./darkred.png": 8236,
	"./grey.png": 7944,
	"./lightblue.png": 5823,
	"./lighterorange.png": 243,
	"./lightgreen.png": 2989,
	"./orange.png": 5416,
	"./purple.png": 6997,
	"./white.png": 8147,
	"./yellow.png": 2465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3358;